import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Button } from '@vibTheme/components/_base/Button';
import { Typography } from '@vibTheme/components/_base/Typography';
import { VibModal } from '@vibTheme/components/VibModal';
import { feeChangeNotice } from '@utils/constants';
import { Dispatch, SetStateAction, useState } from 'react';

type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onDontShowAgain: () => void;
};

export const FeeChangeModal = (props: Props) => {
  const { isOpen, setIsOpen, onDontShowAgain } = props;
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleConfirm = () => {
    if (dontShowAgain) onDontShowAgain();
    setIsOpen(false);
  };

  return (
    <VibModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      containerClassname="w-full max-w-[33rem]"
      hideCloseButton
    >
      <div className="flex items-start justify-between gap-main">
        <Typography component="h2" className="font-semibold">
          Mais lucro para você em cada venda 💰
        </Typography>
        <CloseIcon
          id="close-fee-change-modal"
          className="mt-1 shrink-0 hover:cursor-pointer"
          onClick={() => setIsOpen(false)}
        />
      </div>

      <Typography className="mt-md text-sm">
        As taxas da Vibx foram reduzidas e, a partir de{' '}
        {feeChangeNotice.START_DATE}, passam a ser de{' '}
        {feeChangeNotice.PERCENTAGE_FEE} + {feeChangeNotice.FIXED_FEE} por
        transação.
      </Typography>

      <Typography className="mt-md text-sm">
        Essa atualização permite que você fique com uma parcela maior do valor
        das suas vendas, mantendo a mesma experiência de monetização que você já
        conhece.
      </Typography>

      <Typography className="mt-md text-sm">
        Continue vendendo normalmente. As novas condições já estão sendo
        aplicadas automaticamente.
      </Typography>

      <div className="mt-main overflow-hidden rounded-default border border-solid border-grayDivider">
        <div className="divider grid grid-cols-[1fr_2rem_1fr] items-center bg-black/[0.02] px-md py-sm text-center">
          <Typography className="text-sm font-semibold text-black/60">
            Valor percentual
          </Typography>
          <span />
          <Typography className="text-sm font-semibold text-black/60">
            Taxa Fixa
          </Typography>
        </div>

        <div className="grid grid-cols-[1fr_2rem_1fr] items-center px-md py-sm text-center">
          <Typography className="text-sm">
            {feeChangeNotice.PERCENTAGE_FEE}
          </Typography>
          <Typography className="text-sm text-black/60">+</Typography>
          <Typography className="text-sm">
            {feeChangeNotice.FIXED_FEE}
          </Typography>
        </div>
      </div>

      <div className="mt-main flex flex-col gap-md sm:flex-row sm:items-center sm:justify-between">
        <FormControlLabel
          className="mr-0"
          control={
            <Checkbox
              id="fee-change-dont-show-again"
              size="small"
              checked={dontShowAgain}
              onChange={(evt) => setDontShowAgain(evt.target.checked)}
              className="p-sm text-primary"
            />
          }
          label={
            <Typography className="text-sm text-black/60">
              Não mostrar mais
            </Typography>
          }
        />

        <Button
          id="fee-change-confirm"
          size="medium"
          onClick={handleConfirm}
          className="self-end rounded-default"
        >
          Entendi
        </Button>
      </div>
    </VibModal>
  );
};
